module.exports = __webpack_public_path__ + "static/assets/ad093676c5c19839d4e72ed843e2a281.png";